// Guidance metadata carried by every field definition (PLAN §12.3): help, placeholder, format hint, article link.
export interface FieldGuidance {
  key: string;
  label: string;
  /** What the field means ("The actor's registered legal name."). Shown in the ⓘ tooltip. */
  help?: string;
  /** Example value shown inside the input ("e.g. 1971-03-02 or 'March 1971'"). */
  placeholder?: string;
  /** Helper text under complex fields (dates, amounts, periods). */
  formatHint?: string;
  /** Onboarding article slug for "Learn more →". */
  learnMore?: string;
  required?: boolean;
}

export const helpHref = (slug: string, section?: string) => `/onboarding/${slug}${section ? `#${section}` : ''}`;
